import { ExternalLinkIcon } from '@radix-ui/react-icons'
import Link from 'next/link'

import { templates } from 'lib/constants/templates'
import { getTemplateDeploymentLink } from 'lib/utils/links'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import { IconStyled } from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'
import Card from 'components/atomic/molecules/card'
import LayoutWebsite from 'components/pages/@layouts/layout-website'
import SharedCta from 'components/pages/@shared/cta'

const TemplatesIndexPage = () => {
  return (
    <LayoutWebsite meta={{ title: 'Templates' }}>
      <Box css={{ spaceY: 32, pt: '$6', container: 'xl' }}>
        <Box as="section">
          <Box relative textCenter css={{ container: 'md', spaceY: 4, p: 0 }}>
            <Text
              as="h1"
              size={{ '@initial': '3xl', '@sm': '5xl' }}
              weight="bold"
              align="center"
            >
              Templates
            </Text>
            <Text as="p" size="lg" color="text2">
              Deploy a globally fast GraphQL API in seconds.
            </Text>
          </Box>
        </Box>
        <Box
          grid
          css={{
            container: 'lg',
            gridCols: 1,
            gap: '1.5rem',
            '@md': { gridCols: 2 },
          }}
        >
          {templates.map(({ gitRepoUrl, name, icon, slug, envVars }) => (
            <Card.Root key={name} bgc="3">
              <Card.Body flex="column" justify="center" css={{ spaceY: 4 }}>
                <Box flex items="center" justify="between" css={{ spaceX: 2 }}>
                  <Box flex items="center" css={{ spaceX: 2 }}>
                    <IconStyled as={icon} size="2xl" color="text2" />
                    <Text as="h3" weight="bold" size="2xl">
                      {name}
                    </Text>
                  </Box>
                  <a href={gitRepoUrl} target="_blank" rel="noreferrer">
                    <IconStyled
                      as={ExternalLinkIcon}
                      size="xl"
                      color="text3"
                      css={{ '&:hover': { color: '$text2' } }}
                    />
                  </a>
                </Box>
                <Link
                  href={getTemplateDeploymentLink({
                    templateGitRepoUrl: gitRepoUrl,
                    templateSlug: slug,
                    envVars,
                  })}
                >
                  <Button
                    variant="gradient"
                    width="full"
                    css={{ fontSize: '$lg' }}
                  >
                    Deploy
                  </Button>
                </Link>
              </Card.Body>
            </Card.Root>
          ))}
        </Box>
        <SharedCta />
      </Box>
    </LayoutWebsite>
  )
}

export default TemplatesIndexPage
